import React from "react";
import Synonyms from "./Synonyms";
import "./Meaning.css";

export default function Meaning(props) {
  return (
    <div className="Meaning">
      <div className="speech-badge-container">
        <span className="part-of-speech-tag">{props.meaning.partOfSpeech}</span>
        <div className="badge-accent-line"></div>
      </div>

      <div className="definitions-stack mt-4">
        {props.meaning.definitions.map(function (definition, index) {
          return (
            <div key={index} className="definition-node-item mb-4">
              <div className="definition-text">
                <span className="index-counter">{index + 1}.</span>
                {definition.definition}
              </div>

              {definition.example && (
                <div className="example-block-quote">
                  "{definition.example}"
                </div>
              )}

              {definition.synonyms && definition.synonyms.length > 0 && (
                <div className="mt-3">
                  <Synonyms synonyms={definition.synonyms} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
